import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import store from './store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/','/market','/index', '/login' ,'/register', '/forgetpwd', '/text','/downLoad','/help','/helpDetail','/about','/agrt','/bannerDetail','/notice','/security','/benefits','/benefitsDetail','/signRule','/userAgreement','/settingNew','/setting-newdetail','/questionnaire','/verificationCode'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  if (from.meta.savePosition) {
    to.meta.savePosition = document.body.scrollTop || document.documentElement.scrollTop
  }


  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login' || to.path === '/404') {
      // if is logged in, redirect to the home page
      next() // { path: '/login' }
      NProgress.done()
    } else {
      if (store.state.phone || store.state.email) {
        next()
      } else {
        // 暂时注释
        // store.dispatch('getInfo').then((res) => {
        //   next()
        //   NProgress.done()
        // }).catch(() => {
        //   store.dispatch('resetToken')
        //   NProgress.done()
        // })
        next()
      }
    }
  } else {
    /* has no token*/
    console.log(to.path)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)
      next('/login')
      NProgress.done()
    }
  }
  if(to.path==from.path&&to.path == '/market'){
    window.location.reload()
  }
})

router.afterEach((to, from) => {
  if (to.meta.savePosition) {
      window.scrollTo(0, to.meta.savePosition)
    };
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js